import React, {PureComponent} from 'react'
import cn from 'classnames'
import { connect } from 'react-redux'
import injectStyles from "react-jss"
import {getBottomNavItems} from "../../selectors"


class BottomNav extends PureComponent {

    render() {
        const {classes, bottomNavItems} = this.props;
        if(!bottomNavItems) return null;

        return <div className={classes.container}>
            <div className={cn( classes.row)}>
                {bottomNavItems.map(item => (
                    <a key={item.name} href={item.url} className={cn('ga-track-link-click', classes.link)} data-ga-category={item.ga_category} data-ga-action={item.ga_action} data-ga-label={item.ga_label}>
                        {item.name}
                    </a>
                ))}
            </div></div>
    }
}


const mapStateToProps = (state) => {
    return {
        bottomNavItems: getBottomNavItems(state),
    }
}

export default injectStyles((theme) => ({
    container: {
        background: '#F5F5F5'
    },
    row: {
        maxWidth: theme.convertFromIconicRemValue(26.25),
        width: '100%',
        margin: '0 auto',
    },
    link: {
        textAlign: 'center',
        width: '33.33333%',
        display: 'inline-block',
        fontSize: theme.convertFromIconicRemValue(0.625),
        lineHeight: theme.convertFromIconicRemValue(.625),
        padding: `${theme.convertFromIconicRemValue(0.75)} 0`,
        color: '#464646',
        letterSpacing: theme.convertFromIconicRemValue(0.07),
        ...theme.font.familyBoldStyle,
        textTransform: 'uppercase',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'none'
        },
        [theme.breakpoint('tablet')]: {
            fontSize: theme.convertFromIconicRemValue(0.8125),
            lineHeight: theme.convertFromIconicRemValue(1.21875),
        }

    }
}))(connect(mapStateToProps)(BottomNav))



// WEBPACK FOOTER //
// ./src/components/UniversalNav/BottomNav.js